import { COMPANY_ACTIVATION_STEPPER_NAMESPACE } from '@modules/auth/pages/CompanyActivation/company-activation-stepper';
import { LOGIN_STEPPER_NAMESPACE } from '@modules/auth/pages/Login/login-stepper';
import { PASSWORD_RECOVERY_STEPPER_NAMESPACE } from '@modules/auth/pages/PasswordRecovery/password-recovery-stepper';
import { REGISTER_STEPPER_NAMESPACE } from '@modules/auth/pages/Register/register-stepper';

export const AUTH_FLOW_NAMESPACES: readonly string[] = [
  LOGIN_STEPPER_NAMESPACE,
  REGISTER_STEPPER_NAMESPACE,
  PASSWORD_RECOVERY_STEPPER_NAMESPACE,
  COMPANY_ACTIVATION_STEPPER_NAMESPACE,
];

export const isAuthFlowNamespace = (namespace: string) =>
  AUTH_FLOW_NAMESPACES.includes(namespace);
